//AIzaSyCZzXy4_PivVfP6yCSo9XbkKMxTZcS3s1U
export const YOUTUBE_API_KEY = 'AIzaSyBbIMmPXYw3ZxzvEp7agWtVuFAFgZYWCJU';
export const STUDIO_API_URL = 'https://studio-api.gifebi.ge/';
